import axios from 'axios';
import { CORE_API_URL } from '../utility/Constant';

export const trackSession = data => axios.post(`${CORE_API_URL}/booking_sessions`, data);
